import { isSwimmingSchool } from "../../../../../utils/TicketPassHelper";
import { Ticket } from "../../../../../models/Ticket";

export interface CatchUpLessonsTicketInfo {
  ticket: Ticket;
  count: number;
}

/**
 * Lekcje do odrobienia = wejścia na karnecie minus terminy na liście rezerwacji.
 * Rezygnacja/nieobecność usuwa termin z `exercises` i otwiera lukę; zapis na nowy termin ją zamyka.
 * Tylko passtype 9 (szkółka).
 */
export default function getCatchUpLessonsTickets(tickets: Ticket[]): CatchUpLessonsTicketInfo[] {
  return tickets
    .filter((ticket) => isSwimmingSchool(ticket.passtype))
    .map((ticket) => ({
      ticket,
      count: Math.max(0, (ticket.entrances || 0) - (ticket.exercises?.length || 0)),
    }))
    .filter((info) => info.count > 0);
}
